import { PageId } from 'constants/pages'

export const enum PageIdWoofzNdd75 {
  SUBSCRIPTIONS_NDD_75 = PageId.SUBSCRIPTIONS_NDD_75,
  CHAT_UPSELL_NDD_75 = PageId.CHAT_UPSELL_NDD_75,
  UPSELL_NDD_75 = PageId.UPSELL_NDD_75,
  DOWNLOAD_NDD_75 = PageId.DOWNLOAD_NDD_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
